export const getSearchParamFromUrl = (property: string): string | undefined => {
  const params = new URL(window.location.href).searchParams;
  return params.get(property) || undefined;
};
